import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'

const DelectSelectedModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.deleteSelectedModalVisible}
        onClose={distributeStore.hideDeleteSelectedModal}
    >
        <div className="delete-selected-modal-body">
            <i className="fal fa-circle-exclamation" />

            <Typography type="h3">{i18n.t('deleteSelectedModal.title')}</Typography>

            <br />

            <Typography>
                {i18n.t('deleteSelectedModal.body', { records: distributeStore.selectedUsers.length })}
            </Typography>
        </div>

        <br />

        <div className="delete-selected-modal-buttons">
            <Button
                label={i18n.t('skipLogicModal.goBack')}
                cssClass="regular tertiary"
                onClick={distributeStore.hideDeleteSelectedModal}
            />

            <Button
                label={i18n.t('deleteSelectedModal.yesAction')}
                cssClass="regular error"
                icon="fal fa-circle-xmark"
                onClick={distributeStore.deleteSelected}
            />
        </div>
    </Modal>
)

export default observer(DelectSelectedModal)
